import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7943fd9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-container" }
const _hoisted_2 = {
  key: 0,
  class: "error"
}




export default /*#__PURE__*/_defineComponent({
  props: {
    error: null
  },
  setup(__props: any) {

const props = __props as {
  error: string;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(props.error), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})